"use client";

import React from "react";
import { ScrollToService } from "./ScrollToService";

interface ScrollToControllerProps { }

export const ScrollToController = (props: ScrollToControllerProps): null =>
{
    React.useEffect(() =>
    {
        var service = new ScrollToService();

        return () =>
        {
            service.dispose();
        };
    }, []);

    return null;
};